import { render, staticRenderFns } from "./history.vue?vue&type=template&id=504a9074"
import script from "./history.ts?vue&type=script&lang=js&external"
export * from "./history.ts?vue&type=script&lang=js&external"
import style0 from "./history.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports